import { generalState } from '../../model/details/general';

// Types
import { LeadDetailRawType } from '../../types/Lead';

// Services
import dateToString from '../../services/misc/dateToString';

export default function transformGeneralState(data: LeadDetailRawType) {
    const map = new Map();
    let _transform = {};

    map.set('leadSource', 'leadSource');
    map.set('id', 'leadId');
    map.set('status', 'leadState');
    map.set('customer.type', 'type');
    map.set('externalReferences.armadaCustomerId', 'armadaCustomerId');
    map.set('externalReferences.leasmanCustomerId', 'leasmanCustomerId');

    map.forEach((uiKey, apiKey) => {
        const [type, subKey] = apiKey.split('.');
        const _v = subKey && data[type] ? data[type][subKey] : data[apiKey];

        _transform = {
            ..._transform,
            [uiKey]: _v === null || _v === undefined ? generalState[uiKey] : _v,
        };
    });

    _transform = {
        ..._transform,
        creationTimestamp: dateToString(data.creationTimestamp, 'dateLong'),
    };

    return _transform;
}
